// Dependencies
import styled from 'styled-components';

const BlogPostAuthorInfoStyles = styled.section`
  margin: 0;
  background-color: var(--color-sand);

  .left {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.875rem 0;
    background-color: var(--color-beige);

    .profile-photo-wrap {
      display: inline-block;
      max-width: 15rem;
      max-height: 15rem;
      padding: 1.125rem;
      background-color: #fff;

      .profile-photo {
        aspect-ratio: 1/1;
      }
    }
  }

  .right {
    padding: 3.75rem 2.25rem 3.375rem;

    .heading,
    .name,
    .title {
      font-weight: var(--font-weight-light);
    }

    .heading {
      margin: 0 0 1.5rem;
    }

    .name {
      margin: 0;
    }

    .title {
      font-style: italic;
      text-transform: none;
    }

    .description {
      margin: 1rem 0 0;
    }

    .btn {
      margin: 1.625rem 0 3.25rem;
    }
  }

  @media (min-width: 768px) {
    display: flex;

    .left {
      width: 40%;
      padding: 5.875rem 3rem 5rem;
    }

    .right {
      width: 60%;
      padding: 4.375rem 5.625rem 2.5rem;

      .heading {
        margin: 0 0 2.5rem;
      }
    }
  }
`;

export default BlogPostAuthorInfoStyles;
